import { useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Loader2, ShieldCheck } from "lucide-react";

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontFamily: "'Inter', sans-serif",
      fontSize: "15px",
      color: "#0f172a",
      "::placeholder": { color: "#94a3b8" },
      iconColor: "#059669",
    },
    invalid: { color: "#ef4444", iconColor: "#ef4444" },
  },
};

const StripePaymentForm = ({ clientSecret, onSuccess, onError, amount = 50 }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [cardError, setCardError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    setCardError(null);

    const { error, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
      payment_method: { card: elements.getElement(CardElement) },
    });

    setLoading(false);

    if (error) {
      setCardError(error.message);
      if (onError) onError(error);
    } else if (paymentIntent.status === "succeeded") {
      if (onSuccess) onSuccess(paymentIntent);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      <div>
        <label className="block text-xs font-semibold uppercase tracking-widest text-slate-400 mb-2">
          Carte bancaire
        </label>
        <div className="rounded-xl border border-slate-200 bg-white px-4 py-3.5 focus-within:border-emerald-500 focus-within:ring-1 focus-within:ring-emerald-500 transition-all">
          <CardElement options={CARD_ELEMENT_OPTIONS} />
        </div>
        {cardError && (
          <p className="mt-2 text-xs text-red-500">{cardError}</p>
        )}
      </div>

      <button
        type="submit"
        disabled={!stripe || loading}
        className="w-full flex items-center justify-center gap-2 rounded-xl bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white font-semibold py-3.5 text-sm transition-colors"
      >
        {loading ? (
          <>
            <Loader2 className="h-4 w-4 animate-spin" />
            Traitement…
          </>
        ) : (
          `Payer ${amount.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
        )}
      </button>

      <div className="flex items-start gap-2 text-xs text-slate-400">
        <ShieldCheck className="h-4 w-4 text-emerald-500 flex-shrink-0 mt-0.5" />
        <p className="font-light leading-relaxed">
          Paiement sécurisé via Stripe. Vos données ne sont jamais transmises à Hafani.
        </p>
      </div>
    </form>
  );
};

export default StripePaymentForm;
